import { render } from "./ProductAndProductGroup.vue?vue&type=template&id=6e590bde"
import script from "./ProductAndProductGroup.vue?vue&type=script&lang=js"
export * from "./ProductAndProductGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__